export const toDateInputValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string') {
    const m = value.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  return '';
};

export const sortWeeksChronologically = (weekRows) =>
  [...weekRows].sort((a, b) => {
    const aStart = toDateInputValue(a.start_date) || '';
    const bStart = toDateInputValue(b.start_date) || '';
    if (aStart !== bStart) return aStart.localeCompare(bStart);
    if (a.year !== b.year) return a.year - b.year;
    if (a.week_number !== b.week_number) return a.week_number - b.week_number;
    return a.id - b.id;
  });

export const dateStringToUtcMs = (dateStr) => {
  const ymd = toDateInputValue(dateStr);
  if (!ymd) return null;
  const [y, m, d] = ymd.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
  return Date.UTC(y, m - 1, d);
};

export const findWeekContainingDate = (weekRows, dateStr) => {
  if (!Array.isArray(weekRows) || weekRows.length === 0) return null;
  const pickMs = dateStringToUtcMs(dateStr);
  if (pickMs === null) return null;
  const match = weekRows.find((week) => {
    const startMs = dateStringToUtcMs(week.start_date);
    const endMs = dateStringToUtcMs(week.end_date);
    if (startMs === null || endMs === null) return false;
    return pickMs >= startMs && pickMs <= endMs;
  });
  return match || null;
};
